angular.module('gym.apiDetails', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.apiDetails', {
    url: '/api_details',
    template: require('templates/gyms/integrations/index.html.slim')
  });
}]);
